<template>
  <v-container fluid>
    <v-row>
      <global-EventFilterMenu
        header="Event Filter"
        showStallholders
        headerButtonText="Takings Report"
        :headerButtonAction="generateTakingsReport"
      />
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-chart-pie </v-icon>
            Total Sales
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-summary :loading="takingsTotalSalesLoading">
                  <v-card class="primary mb-2" dark>
                    <v-card-title class="py-1 title">
                      <v-icon left> mdi-cash </v-icon>
                      Total Sales:
                    </v-card-title>
                    <v-card-text class="headline font-weight-bold">
                      <!-- $11,156,527,456.00 -->
                      {{ takingsTotalSalesData.NetSales | currency }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>

                <skeletons-summary :loading="takingsTotalSalesLoading">
                  <v-card class="secondary mb-2" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-cash </v-icon>
                      Cash Sales:
                    </v-card-title>
                    <v-card-text class="headline font-weight-bold">
                      <!-- $11,156,527,456.00 -->
                      {{ takingsTotalSalesData.Cash | currency }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>

                <skeletons-summary :loading="takingsTotalSalesLoading">
                  <v-card class="secondary mb-2" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-cash </v-icon>
                      Card Sales:
                    </v-card-title>
                    <v-card-text class="headline font-weight-bold">
                      <!-- $11,156,527,456.00 -->
                      {{ takingsTotalSalesData.Card | currency }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>

                <skeletons-summary :loading="takingsTotalSalesLoading">
                  <v-card class="secondary mb-2" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-cash </v-icon>
                      Voucher Sales:
                    </v-card-title>
                    <v-card-text class="headline font-weight-bold">
                      <!-- $11,156,527,456.00 -->
                      {{ takingsTotalSalesData.Voucher | currency }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>
              </v-col>

              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-graph :loading="takingsTotalSalesLoading">
                  <charts-pie
                    :chartdata="totalSalesDonutChartData"
                    :options="options"
                  />
                </skeletons-graph>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-chart-pie </v-icon>
            Total Sales By Stall
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col lg="12" md="12" sm="12" cols="12">
                <skeletons-graph>
                  <charts-pie
                    :chartdata="takingsStallComparisonDonutChartData"
                    :options="options"
                  />
                </skeletons-graph>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-chart-line </v-icon>
            Total Sales Timeline
          </v-card-title>
          <v-card-text>
            <skeletons-graph :loading="takingsTotalSalesLoading">
              <charts-line
                :chartdata="stallComparisonTimelineChartData"
                isCurrency
              />
            </skeletons-graph>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-file-table </v-icon>
            Stall Takings Table
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              v-model="selectedTransaction"
              :headers="headers"
              :items="stallTableData"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-file-table </v-icon>
            Stall Tags Table
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              v-model="selectedTransaction"
              :headers="headersForTagTable"
              :items="stallTagsData"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";

export default {
  data: () => ({
    takingsTotalSalesData: {
      NetSales: 0,
      Cash: 0,
      Card: 0,
      Voucher: 0,
    },

    totalSalesDonutChartData: {
      labels: ["No Data Available"],
      datasets: [
        {
          backgroundColor: [
            "rgb(255, 99, 132)",
            "rgb(54, 162, 235)",
            "rgb(255, 205, 86)",
          ],
          data: [1],
          hoverBorderWidth: 3,
        },
      ],
    },
    takingsStallComparisonDonutChartData: {
      labels: ["No Data Available"],
      datasets: [
        {
          backgroundColor: [
            "rgb(255, 99, 132)",
            "rgb(54, 162, 235)",
            "rgb(255, 205, 86)",
          ],
          data: [1],
          hoverBorderWidth: 3,
        },
      ],
    },

    stallComparisonTimelineChartData: {
      labels: ["No Data Available"],
      datasets: [
        {
          label: "No Data Available",
          borderColor: "#FF0E00",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "#FF0E00",
          backgroundColor: "transparent",
          data: [0],
        },
      ],
    },

    stallTableData: [],

    stallTagsData: [],

    selectedTransaction: [],
    headers: [
      { text: "Stall Name", value: "Stall Name" },
      {
        text: "Total Takings",
        value: "Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Cash Takings",
        value: "Cash Takings",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Card Takings",
        value: "Card Takings",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Voucher Takings",
        value: "Voucher Takings",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      { text: "# of Terminals", value: "Number of Terminals" },
      {
        text: "Avg $ per Terminal",
        value: "Average per Terminal",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
    ],

    headersForTagTable: [
      { text: "Tag Name", value: "Stall Tag Name" },
      {
        text: "Total Takings",
        value: "Sales",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Cash Takings",
        value: "Cash Takings",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Card Takings",
        value: "Card Takings",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      {
        text: "Voucher Takings",
        value: "Voucher Takings",
        sort: (a, b) =>
          parseFloat(a.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.replace(/[^0-9.-]+/g, "")),
      },
      // REMOVED THESE BECAUSE THEY ARE NOT USED - Scott's request 26/6/25
      // { text: "# of Terminals", value: "Number of Terminals" },
      // {
      //   text: "Avg $ per Terminal",
      //   value: "Average per Terminal",
      //   sort: (a, b) => parseFloat(a.replace(/[^0-9.-]+/g, "")) - parseFloat(b.replace(/[^0-9.-]+/g, "")),
      // }
    ],

    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        labels: {
          fontColor: "white",
        },
      },
      tooltips: {
        callbacks: {
          label(tooltipItem, data) {
            const totalValue = data.datasets[0].data.reduce(
              (acc, value) => acc + parseInt(value),
              0
            );
            const currentValue = parseInt(
              data.datasets[0].data[tooltipItem.index]
            );
            const percentage = ((currentValue / totalValue) * 100).toFixed(2);
            return `${data.labels[tooltipItem.index]}: ${new Intl.NumberFormat(
              "en-US",
              { style: "currency", currency: "USD" }
            ).format(
              data.datasets[0].data[tooltipItem.index]
            )} (${percentage})%`;
          },
        },
      },
    },

    //loading
    stallComparisonLoading: true,
    timelineLoading: true,
    stallTableLoading: true,
  }),

  computed: {
    ...mapState("dashboard", ["takingsTotalSales", "takingsTotalSalesLoading"]),
    ...mapState("filter", ["globalEventFilter"]),
  },

  methods: {
    ...mapActions("dashboard", ["prepareReport", "getReports"]),

    generateTakingsReport() {
      this.prepareReport("takingsReport").then((takingsReport) => {
        console.log("takingsReport: ", takingsReport);
        iziToast.success({
          title: "Takings Report",
          message: "Generating takings report, standby",
          position: "topRight",
        });
        this.getReports(takingsReport)
          .then((response) => {
            console.log("getTakingsReport Response: ", response);
            this.presignedurl = response.S3presignedurl;
            window.open(this.presignedurl, "_blank");
          })
          .catch((err) => {
            console.error(err);
            iziToast.warning({
              title: "Takings Report",
              message: "Error getting Takings Report, please contact TSG",
              position: "center",
            });
          });
      });
    },

    // ProcessTakingsTotalSalesData
    ProcessTakingsTotalSalesData() {
      const totalSalesData = this.takingsTotalSales?.total_sales_data || {};

      if (totalSalesData?.NetSales >= 0) {
        if (totalSalesData.NetSales) {
          this.takingsTotalSalesData.NetSales = totalSalesData.NetSales;
        } else {
          this.takingsTotalSalesData.NetSales = 0;
        }
        if (totalSalesData.Cash) {
          this.takingsTotalSalesData.Cash = totalSalesData.Cash;
        } else {
          this.takingsTotalSalesData.Cash = 0;
        }
        if (totalSalesData.Card) {
          this.takingsTotalSalesData.Card = totalSalesData.Card;
        } else {
          this.takingsTotalSalesData.Card = 0;
        }
        if (totalSalesData.Voucher) {
          this.takingsTotalSalesData.Voucher = totalSalesData.Voucher;
        } else {
          this.takingsTotalSalesData.Voucher = 0;
        }
      }
    },

    // ProcessTakingsTotalSalesDataPie
    ProcessTakingsTotalSalesDataPie() {
      const totalSalesData = this.takingsTotalSales?.total_sales_data || {};
      if (totalSalesData?.NetSales > 0) {
        this.totalSalesDonutChartData = {
          labels: ["Cash", "Card", "Voucher"],
          datasets: [
            {
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
              ],
              data: [
                totalSalesData.Cash,
                totalSalesData.Card,
                totalSalesData.Voucher,
              ],
              hoverBorderWidth: 3,
            },
          ],
        };
      } else {
        this.totalSalesDonutChartData = {
          labels: ["No data available"],
          datasets: [
            {
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
              ],
              data: [1],
              hoverBorderWidth: 3,
            },
          ],
        };
      }
    },

    // ProcessTakingsStallComparisonDonutDataPie
    ProcessTakingsStallComparisonDonutDataPie() {
      const comparisonData =
        this.takingsTotalSales?.stall_comparison_data || [];

      if (comparisonData.length > 0) {
        this.takingsStallComparisonDonutChartData = {
          labels: comparisonData.map((x) => x["Stall Name"]),
          datasets: [
            {
              backgroundColor: this.$generateColors.getColors(
                comparisonData.length
              ),
              data: comparisonData.map((x) => x.Sales),
              hoverBorderWidth: 3,
            },
          ],
        };
      } else {
        this.takingsStallComparisonDonutChartData = {
          labels: ["No data available"],
          datasets: [
            {
              backgroundColor: this.$generateColors.getColors(1), // Just get one color for no data
              data: [1],
              hoverBorderWidth: 3,
            },
          ],
        };
      }
    },

    // ProcessStallComparisonTimelineChartData
    ProcessStallComparisonTimelineChartData() {
      const timelineData =
        this.takingsTotalSales?.stall_comparison_timeline || [];

      if (timelineData.length > 0 && timelineData[0]?.Stalls?.length > 0) {
        this.stallComparisonTimelineChartData = {
          labels: timelineData[0].Stalls.map((obj) => obj.Timestamp),
          datasets: timelineData.map((obj, index) => ({
            label: obj["Stall Name"],
            borderColor: this.$generateColors.getColor(index),
            pointBackgroundColor: "white",
            borderWidth: 3,
            pointBorderColor: this.$generateColors.getColor(index),
            backgroundColor: "transparent",
            data: obj.Stalls?.map((stall) => stall.SalesAmount) || [],
          })),
        };
      } else {
        this.stallComparisonTimelineChartData = {
          labels: ["No Data Available"],
          datasets: [
            {
              label: "No Data Available",
              borderColor: "#FF0E00",
              pointBackgroundColor: "white",
              borderWidth: 1,
              pointBorderColor: "#FF0E00",
              backgroundColor: "transparent",
              data: [0],
            },
          ],
        };
      }
    },

    // ProcessStallTableData
    ProcessStallTableData() {
      const stallTable = this.takingsTotalSales?.stall_table_data || [];
      if (stallTable?.length > 0) {
        this.stallTableData = stallTable.map((item) => ({
          "Stall Name": item["Stall Name"],
          Sales:
            item["Sales"] !== undefined
              ? this.$options.filters.currency(item["Sales"])
              : "N/A",
          "Cash Takings":
            item["Cash Takings"] !== undefined
              ? this.$options.filters.currency(item["Cash Takings"])
              : "N/A",
          "Card Takings":
            item["Card Takings"] !== undefined
              ? this.$options.filters.currency(item["Card Takings"])
              : "N/A",
          "Voucher Takings":
            item["Voucher Takings"] !== undefined
              ? this.$options.filters.currency(item["Voucher Takings"])
              : "N/A",
          "Number of Terminals": item["Number of Terminals"],
          "Average per Terminal":
            item["Average per Terminal"] !== undefined
              ? this.$options.filters.currency(item["Average per Terminal"])
              : "N/A",
        }));
      } else {
        this.stallTableData = [];
      }
    },

    processStallTagsData() {
      const stallTagsData = this.takingsTotalSales?.stall_tags_table_data || [];
      console.log("stallTagsData: ", stallTagsData);
      console.log("takingsTotalSales: ", this.takingsTotalSales);
      if (stallTagsData?.length > 0) {
        this.stallTagsData = stallTagsData.map((item) => ({
          "Stall Tag Name": item["Stall Tag Name"],
          Sales:
            item["Sales"] !== undefined
              ? this.$options.filters.currency(item["Sales"])
              : "N/A",
          "Cash Takings":
            item["Cash Takings"] !== undefined
              ? this.$options.filters.currency(item["Cash Takings"])
              : "N/A",
          "Card Takings":
            item["Card Takings"] !== undefined
              ? this.$options.filters.currency(item["Card Takings"])
              : "N/A",
          "Voucher Takings":
            item["Voucher Takings"] !== undefined
              ? this.$options.filters.currency(item["Voucher Takings"])
              : "N/A",
        }));
      } else {
        this.stallTagsData = [];
      }
    },
  },

  watch: {
    "takingsTotalSales.total_sales_data": {
      handler() {
        this.ProcessTakingsTotalSalesData();
        this.ProcessTakingsTotalSalesDataPie();
      },
      immediate: true,
    },

    "takingsTotalSales.stall_comparison_data": {
      handler() {
        this.ProcessTakingsStallComparisonDonutDataPie();
      },
      immediate: true,
    },

    "takingsTotalSales.stall_comparison_timeline": {
      handler() {
        this.ProcessStallComparisonTimelineChartData();
      },
      immediate: true,
    },

    "takingsTotalSales.stall_table_data": {
      handler() {
        this.ProcessStallTableData();
      },
      immediate: true,
    },

    "takingsTotalSales.stall_tags_table_data": {
      handler() {
        this.processStallTagsData();
      },
      immediate: true,
    },
  },

  created() {
    // this.updateDashboard()
    var self = this;
    setTimeout(function () {
      self.stallComparisonLoading = false;
      self.timelineLoading = false;
      self.stallTableLoading = false;
    }, 2000);
  },
  filters: {
    currency(value) {
      var formatter = new Intl.NumberFormat("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return "$" + formatter.format(value);
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
